import React, { forwardRef } from 'react';
import useMapAnimateToStyle from './use-map-animate-to-style';
import Animated from 'react-native-reanimated';
// https://www.framer.com/blog/posts/magic-motion/
export default function redripify(ComponentWithoutAnimation) {
    const Component = Animated.createAnimatedComponent(ComponentWithoutAnimation);
    const withAnimations = () => {
        const withStyles = forwardRef(function Wrapped({ animate, style, from = false, transition, delay, state, stylePriority, onDidAnimate, exit, ...props }, ref) {
            const animated = useMapAnimateToStyle({
                animate,
                from,
                transition,
                delay,
                state,
                stylePriority,
                onDidAnimate,
                exit,
            });
            return (React.createElement(Component, Object.assign({}, props, { style: [style, animated.style], ref: ref })));
        });
        return withStyles;
    };
    return withAnimations;
}
